import { Component, ReactNode } from "react"

import moment from "moment"

import { NUMBER_PATTERN, OBJECTS_NAMES_PATTERN } from '../../libs/validation/stringRegex'
import { numberValidation  } from '../../libs/validation/remoteValidationAbstract'
import { objectsNamesValidation } from "../../libs/validation/remoteValidationAbstract"
import { powerValidation } from "./ShipValidation"

import NoMotorPrivacy from '../../components/privacy/NoMotorPrivacy'

import { UserType } from "../../libs/user/User";

import Input from '../../libs/ui/inputs/Input'
import Select from '../../libs/ui/inputs/Select'

interface ShipStepThreeProps {
    kw: number | undefined
    cavalli: number | undefined
    matricola: string | undefined
    anno: number | undefined
    alimentazione: string | undefined
    marca: string | undefined
    ormeggio: string | undefined
    utilizzo: string | undefined

    noMotorPrivacy: any

    utilizzi: any
    alimentazioni: any
    luoghi: any

    user: UserType | undefined

    kwError: string | undefined
    cavalliError: string | undefined
    matricolaError: string | undefined
    annoError: string | undefined
    alimentazioneError: string | undefined
    marcaError: string | undefined
    ormeggioError: string | undefined
    utilizzoError: string | undefined

    noMotorPrivacyError: string | undefined

    updateKwCallBack: Function
    updateCavalliCallBack: Function
    updateMatricolaCallBack: Function
    updateAnnoCallBack: Function
    updateAlimentazioneCallBack: Function
    updateMarcaCallBack: Function
    updateOrmeggioCallBack: Function
    updateUtilizzoCallBack: Function

    updateNoMotorPrivacyCallBack: Function
}

interface ShipStepThreeStatus {
    kwError: string | undefined
    cavalliError: string | undefined
}

class ShipStepThree extends Component<ShipStepThreeProps, ShipStepThreeStatus> {

    constructor (props: any) {
        super (props)

        this.state = {
            kwError: undefined,
            cavalliError: undefined
        }

        this.annoValidation = this.annoValidation.bind(this)
        this.cavalliValidation = this.cavalliValidation.bind(this)
        this.kwValidation = this.kwValidation.bind(this)
        this.setPowerError = this.setPowerError.bind(this)
    }

    render (): ReactNode {
        return (
            <>
                <div className="col-12">
                    <Input 
                        id="kw" name='kw'
                        label='Potenza del motore (in KW)'
                        value={this.props.kw?.toString()}
                        type='number'
                        step='1'
                        min='1'
                        regexp={NUMBER_PATTERN}
                        remoteValidation={this.kwValidation}
                        errorDisplayMsg={this.state.kwError ?? 'Valore non valido'}
                        callback={this.props.updateKwCallBack}
                        error={this.state.kwError ?? this.props.kwError}
                        onFocus={ () => this.setState({cavalliError: undefined, kwError: undefined})}
                    />

                    <Input 
                        id="cavalli" name='cavalli'
                        label='Cavalli fiscali del motore'
                        value={this.props.cavalli?.toString()}
                        type='number'
                        step='1'
                        min='1'
                        regexp={NUMBER_PATTERN}
                        remoteValidation={this.cavalliValidation}
                        errorDisplayMsg={this.state.cavalliError ?? 'Valore non valido'}
                        callback={this.props.updateCavalliCallBack}
                        error={this.state.cavalliError ?? this.props.cavalliError}
                        onFocus={ () => this.setState({cavalliError: undefined, kwError: undefined})}
                    />

                    <Input 
                        id="matricola" name='matricola'
                        label='Matricola o CIN'
                        value={this.props.matricola}
                        type='string'
                        maxLength={100}
                        regexp={OBJECTS_NAMES_PATTERN}
                        remoteValidation={objectsNamesValidation}
                        callback={this.props.updateMatricolaCallBack}
                        error={this.props.matricolaError}
                    />

                    <Input 
                        id="anno" name='anno'
                        label='Anno di costruzione del motore'
                        value={this.props.anno?.toString()}
                        type='number'
                        step='1'
                        min='1900' max={moment().year()} 
                        regexp={this.annoValidation}
                        remoteValidation={numberValidation}
                        errorDisplayMsg='Valore non valido'
                        callback={this.props.updateAnnoCallBack}
                        error={this.props.annoError}
                    />

                    <Select
                        id='alimentazione' name='alimentazione'
                        label='Alimentazione del motore' 
                        value={this.props.alimentazione}
                        options={this.props.alimentazioni}
                        callback={this.props.updateAlimentazioneCallBack}
                        error={this.props.alimentazioneError}
                    />

                    <Input 
                        id="marca" name='marca'
                        label='Marca del motore'
                        value={this.props.marca}
                        type='string'
                        maxLength={100}
                        regexp={OBJECTS_NAMES_PATTERN}
                        remoteValidation={objectsNamesValidation}
                        callback={this.props.updateMarcaCallBack}
                        error={this.props.marcaError}
                    />

                    <Select
                        id='ormeggio' name='ormeggio'
                        label='Luogo (o stato estero) in cui è ormeggiata la barca' 
                        value={this.props.ormeggio}
                        options={this.props.luoghi}
                        callback={this.props.updateOrmeggioCallBack}
                        error={this.props.ormeggioError}
                    />

                    <Select
                        id='utilizzo' name='utilizzo'
                        label='Tipologia d’uso' 
                        value={this.props.utilizzo}
                        options={this.props.utilizzi}
                        callback={this.props.updateUtilizzoCallBack}
                        error={this.props.utilizzoError}
                    />
                </div>

                <NoMotorPrivacy 
                    id='noMotorPrivacy'
                    basePrivacy={this.props.noMotorPrivacy}
                    isLogged={this.props.user !== undefined}
                    callback={this.props.updateNoMotorPrivacyCallBack}
                    error={this.props.noMotorPrivacyError}
                />
            </>
        )
    }

    private annoValidation (anno: string | number | undefined) {
        if (anno === undefined) {
            return true;
        }

        let annoNumber = Number(anno)
        
        return 1900 < annoNumber && annoNumber <= moment().year()
    }

    private cavalliValidation (cavalli: number | undefined) {
        this.setState ({
            kwError: undefined,
            cavalliError: undefined
        })

        if (cavalli === undefined) {
            return true;
        }

        return powerValidation (
            cavalli,
            this.props.kw,
            this.setPowerError
        )
    }

    private kwValidation (kw: number | undefined) {
        this.setState ({
            kwError: undefined,
            cavalliError: undefined
        })

        if (kw === undefined) {
            return true;
        }

        return powerValidation (
            this.props.cavalli,
            kw,
            this.setPowerError
        )
    }

    private setPowerError () {
        this.setState ({
            kwError: 'Combinazione non valida',
            cavalliError: 'Combinazione non valida'
        })
    }
}

export default ShipStepThree